import React from 'react';
import ReactDOM from "react-dom/client";
import * as amplitude from '@amplitude/analytics-browser';

import App from './routes/App';
import { Clock } from './Clock';

amplitude.init("be1ccb47296ae3b0666710e7a11f4b57");

const app = ReactDOM.createRoot(document.getElementById("app"));

app.render(<App />);

const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.id = '#canvas';
document.querySelector('#mesh-gradient').appendChild(canvas);

const clock = new Clock(true);
let polygons = [];

const COLORS = [
    'rgb(157, 13, 240)'
];
let WIDTH = canvas.clientWidth;
let HEIGHT = canvas.clientHeight;
let SCALE = window.devicePixelRatio;

function resize() {
    // Call this on window resize
    SCALE = window.devicePixelRatio;
    WIDTH = canvas.clientWidth;
    HEIGHT = canvas.clientHeight;
    canvas.width = WIDTH * SCALE;
    canvas.height = HEIGHT * SCALE;
    ctx.scale(SCALE, SCALE);
}

function drawPolygon(nbSides, radius, x, y, theta, ctx) {
    let rad = radius * (window.innerWidth / window.innerHeight) * 0.5;
    var step = (2 * Math.PI) / nbSides;
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(theta);
    ctx.beginPath();
    ctx.moveTo(rad, 0); // Start from polar coord 0
    for (var i = 0; i < nbSides; i++) {
        ctx.lineTo(rad * Math.cos(i * step), rad * Math.sin(i * step)); // Parametric circ
    }
    ctx.closePath();
    ctx.stroke();
    ctx.fill();
    ctx.restore();
}

function generate() {
    const nbPolygons = 5;
    const minSpeed = 0.0;
    const maxSpeed = 0.4;

    for (let i = 0; i < nbPolygons; i++) {
        polygons.push({
            nbSides: Math.max(Math.floor(Math.random() * 8), 6), // Random number of sides (with at least 6 sides)
            radius: Math.random() * 100 + 300, // Random radius between 300 - 400
            x: WIDTH * Math.random(), // Random x on canvas
            y: HEIGHT * Math.random(), // Random y on canvas
            speed: Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed, // Velocity, random float from 1.6 to 2.0
            color: COLORS[i % COLORS.length], // Pick color sequentially
            direction: Math.PI * 2 * Math.random() // Random direction
        });
    }
}

function animate() {
    const t = clock.getElapsedTime();
    ctx.globalCompositeOperation = 'screen';
    ctx.clearRect(0, 0, WIDTH, HEIGHT);

    for (var i = 0; i < polygons.length; i++) {
        var polygon = polygons[i];
        ctx.strokeStyle = polygon.color;
        ctx.fillStyle = polygon.color;

        // Move polygon in predef. direction
        polygon.x += Math.cos(polygon.direction) * polygon.speed;
        polygon.y += Math.sin(polygon.direction) * polygon.speed;

        // Boundary check
        var off = polygon.radius + 30;
        if (polygon.x > WIDTH + off) polygon.x = -off + 5;
        if (polygon.y > HEIGHT + off) polygon.y = -off + 5;
        if (polygon.x < -off) polygon.x = WIDTH + off - 5;
        if (polygon.y < -off) polygon.y = HEIGHT + off - 5;

        // Draw it
        drawPolygon(polygon.nbSides, polygon.radius, polygon.x, polygon.y, (i * Math.PI) / 2 + t / 5, ctx);
    }

    window.requestAnimationFrame(animate);
}

generate(); // Generate polygons
resize(); // Resize canvas

window.requestAnimationFrame(animate); // Start animation loop
window.addEventListener('resize', resize, { passive: true }); // call resize() on window resize
